import { useRouter } from 'solito/navigation';

export const useNavigation = () => {
  const router = useRouter();

  const reset = (options: { index?: number; routes: any[] }) => {
    const targetRoute = options?.routes[0];

    console.log('navigation', options?.routes[0]);

    if (typeof targetRoute === 'string') {
      // Replace directly if the route is a string
      const path = targetRoute.endsWith('/index')
        ? targetRoute.replace(/\/index$/, '') // Remove '/index' from the end
        : targetRoute;

      const formattedPath =
        path === '(tabs)'
          ? 'home'
          : path.startsWith('(tabs)')
            ? path.replace(/^\(tabs\)\//, 'home')
            : path;

      router.replace(`/${formattedPath}`);
    } else if (targetRoute?.name) {
      // Replace using the name property if route is an object
      const path = targetRoute.name.endsWith('/index')
        ? targetRoute.name.replace(/\/index$/, '') // Remove '/index' from the end
        : targetRoute.name;

      let formattedPath =
        path === '(tabs)'
          ? 'home'
          : path.startsWith('(tabs)')
            ? path.replace(/^\(tabs\)\//, 'home')
            : path;

      const { params } = targetRoute;

      if (params) {
        Object.keys(params).forEach((key) => {
          formattedPath = formattedPath.replace(`[${key}]`, params[key]);
        });
      }

      // Format query parameters from params
      const queryParams = new URLSearchParams(params).toString();

      const finalPath = queryParams ? `/${formattedPath}?${queryParams}` : `/${formattedPath}`;

      console.log("🚀 ~ reset ~ finalPath:", finalPath)
      router.replace(finalPath);
    } else {
      throw new Error('Invalid route provided to reset');
    }
  };

  const canGoBack = () => {
    // return window.history.cangoBack();
    if (window.history.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const setOptions = (options: any) => {};

  const goBack = () => {
    router.back();
  };

  return {
    reset,
    canGoBack,
    setOptions,
    goBack,
  };
};

export default useNavigation;
